export default {"src":"/_next/static/media/CourtTrain.4f1e841f.svg","height":150,"width":110,"blurWidth":0,"blurHeight":0};